export const NUM_CURATED_TRAILS = 450; // thousand
export const NUM_USERS = 65; // million
export const LOGGED_DISTANCE = 1.7702784e12; // meters
